import { apiFetch } from '../apiFetch'

export const postBetaSignup = (email) =>
  apiFetch({ method: 'POST', path: '/beta_signup', payload: { email } })

export const postHostBetaSignup = (payload) =>
  apiFetch({ method: 'POST', path: '/beta_signup', payload })

export const searchBusinesses = (q) =>
  apiFetch({ path: `/businesses/search?q=${encodeURIComponent(q)}` })

export const getValidateInvite = (code) =>
  apiFetch({ path: `/validate_invite?code=${encodeURIComponent(code)}` })
